












































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Page } from "yellowfin-ui-lib";
import { Attivita } from "@/data/models/attivita.model";

@Component({})
export default class AttivitaTable extends Vue {
  eventUrl: string = process.env.VUE_APP_EVENT_URL as string;

  enabledcolsconf: string = process.env.VUE_APP_CORSI_COLONNE as string;
  enabledcols = {
    titolo: true,
    data: true,
    tipo: true,
    settore: true,
    durata: true,
    costo: true,
    cfp: false,
    posti: true,
    iscrizione: true,
    sede: true,
  };

  now: Date = new Date();

  @Prop() data!: Attivita[];
  @Prop() page!: Page;
  @Prop() loading!: boolean;

  base = "";
  firstload = true;

  @Watch("data")
  onDataChange() {
    this.firstload = false;
  }

  getDate(row: Attivita) {
    if (row.giornate.length === 1) {
      return row.giornate[0].inizio.toLocaleDateString([], {
        hour: "2-digit",
        minute: "2-digit",
      });
    } else {
      return (
        row.giornate[0].inizio.toLocaleDateString() +
        " - " +
        row.giornate[row.giornate.length - 1].inizio.toLocaleDateString([])
      );
    }
  }

  onPageChange(page: number) {
    this.$emit("page", page);
  }

  beforeMount() {
    const uri = window.location.search.substring(1);
    const params = new URLSearchParams(uri);
    const path = location.pathname;
    if (params) {
      this.base = path + "?" + uri + "&profileid=";
    } else {
      this.base = path + "?profileid=";
    }

    if (this.enabledcolsconf) {
      const enabledcols = this.enabledcolsconf.split(",");
      if (enabledcols) {
        this.enabledcols = enabledcols.reduce((acc: any, c: string) => {
          acc[c] = true;
          return acc;
        }, {});
      }
    }
  }
}
